<template>
    <div class="row stdenis-about">
        <div class="white-overlay">
            <div class="row">
                <div class="container">
                    <header class="stdenis-header pd-t-30">
                        <h2>All Societies</h2>
                        <p>
                            St Denis Catholic Church Akoka has over 40 different societies. Browse through and feel free to reach out and join
                        </p>
                    </header>
                    <div class="row stdenis-about-col">

                        <div class="col-lg-4 col-md-12" v-for="listitems in societiesList" :key="listitems.name">
                            <div class="about-col">
                                <div class="img">
                                    <template v-if="listitems.logo !== ''">
                                        <img :src="listitems.logo" class="about-img">
                                    </template>
                                    <template v-else>
                                        <img src="../assets/logo.jpeg" class="about-img">
                                    </template>
                                    <div class="abt-icon">
                                        <i class="icon "></i>
                                    </div>
                                </div>
                                <h2 class="about-title">
                                    <a href="#">{{listitems.name}}</a>
                                </h2>
                                <p>
                                    Meeting days: {{listitems.meetingTime}}<br>
                                    Venue: {{listitems.meetingVenue}}<br>
                                    Contact: {{listitems.contact}}
                                </p>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {firestoreDB} from "../config/firebase";

    const societiesRef = firestoreDB.collection("societies");

    export default {
        name: "Societies",
        data(){
            return {
                societiesList: []
            }
        },
        methods:{
            populateSocieties(){
                societiesRef.get().then((docSnapshots) => {
                    if(!docSnapshots.empty){
                        docSnapshots.forEach((doc) => {
                            this.societiesList.push(doc.data());
                        })
                    }
                })
            }
        },
        created() {
            window.scrollTo(0, 0);
            this.populateSocieties();
        }
    }
</script>

<style scoped>

</style>